import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { getStoreImageUrl, toStoreImageAltText } from 'lib/image';

import APP from 'constants/app';

const getHeadingText = (isExclusivelyCoupon, storeName) =>
  isExclusivelyCoupon
    ? `Cupons ${storeName}  `
    : `Ofertas e cupons ${storeName}  `;

const StoreSummary = ({
  isExclusivelyCoupon,
  isStoreVerified,
  storeDomain,
  storeImage,
  storeName,
}) => (
  <header className="grid auto-cols-max gap-x-4 gap-y-1 lg:gap-x-6">
    <Avatar
      className="row-span-2"
      description={toStoreImageAltText(storeName)}
      icon="store"
      size="size1"
      src={
        storeImage.startsWith(APP.LOCAL_IMAGE_PATH)
          ? storeImage
          : getStoreImageUrl(storeImage, 85)
      }
    />
    <Heading
      as="h1"
      className="col-start-2 inline-flex max-w-72 items-center whitespace-break-spaces lg:max-w-full"
      size="size2"
    >
      {getHeadingText(isExclusivelyCoupon, storeName)}
      {isStoreVerified && <Icon name="verified-color" size="size3" />}
    </Heading>
    {storeDomain && (
      <Text className="col-start-2 row-start-2 text-neutral-high-500">
        {storeDomain}
      </Text>
    )}
  </header>
);

StoreSummary.propTypes = {
  isExclusivelyCoupon: PropTypes.bool,
  isStoreVerified: PropTypes.bool.isRequired,
  storeDomain: PropTypes.string,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
};

export default StoreSummary;
